import Diversion from './Diversion';

export default Diversion;



// WEBPACK FOOTER //
// ./src/components/Diversion/index.js